import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";

const defaultOptions = {
    chart: {
        animation: false,
        type: "pie",
        plotBackgroundColor: "transparent",
        backgroundColor: "transparent",
        height: "500px",
        marginBottom: 160
    },
    title: {
        text: "",
        style: {
            color: "#FFF",
            font: "normal normal bold 24px/28px Arial"
        }
    },
    credits: {
        enabled: false,
    },
    exporting: {
        enabled: false
    },
    plotOptions: {
        pie: {
            dataLabels: {
                enabled: false,
            },
            states: {
                inactive: {
                    opacity: 1,
                },
            },
            borderWidth: 0,
            showInLegend: true
        },
        series: {
            animation: false,
        }
    },
    series: [{
        innerSize: "80%",
        point: {
            events: {
                legendItemClick: function () {
                return false; // <== cancel the default action
                },
            },
        },
        data: []
    }],
    tooltip: {
        backgroundColor: "#FFF",
        borderRadius: 8,
        borderWidth: 1,
        padding: 14,
        style: {
            color: "#333333",
            fontSize: "14px",
            fontFamily: "Arial"
        }
    },
    legend: {
        itemStyle: {
          color: "#FFF",
          font: "normal normal normal 16px/27px Arial"
        },
        verticalAlign: "bottom",
        align: "center",
        backgroundColor: "transparent",
        padding: 20,
        itemMarginTop: 5,
        itemMarginBottom: 10,
        symbolRadius: 0,
        width: "100%"
    }
};

const getChartOptions = (height, title, data, tooltipFormatter) => {
    let chartOptions = {...defaultOptions};
    chartOptions.series[0].data = data
    if (height) {
        chartOptions.chart.height = height;
    }
    if(title) {
        chartOptions.title.text = title;
    }
    if(typeof tooltipFormatter === "function") {
        chartOptions.tooltip.useHTML = true;
        chartOptions.tooltip.formatter = tooltipFormatter;
    }
    return chartOptions;
};

const RingChart = ({height, title, data, tooltipFormatter}) => {
    let chartOptions = getChartOptions(height, title, data, tooltipFormatter);
    return (
        <div>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </div>
    );
};

export default RingChart;